import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getFileIcon } from "../../../utils";
import { useEffect } from "react";

const MyInputFile = (props) => {
  const {
    hint = "",
    className = "",
    name,
    prefix = "",
    onChange = () => {},
    ...rest
  } = props;

  const { t } = useTranslation();
  const {
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  const files = watch(name);

  const handleChange = (e) => {
    if (rest.multiple) {
      const selectedFiles = Array.from(e.target.files);
      const newFiles = [];

      const existingFileIds = new Set(files.map((file) => file.fileId));

      selectedFiles.forEach((file) => {
        const newFileName = `${prefix}${file.name}`;
        const newFile = new File([file], newFileName, { type: file.type });
        const newFileId = `temp-fileId-${newFile.name}-${new Date().getTime()}`;

        if (!existingFileIds.has(newFileId)) {
          newFiles.push({
            file: newFile,
            name: newFile.name,
            fileId: newFileId,
          });
          existingFileIds.add(newFileId);
        }
      });

      const updatedFiles = [...files, ...newFiles];
      setValue(name, updatedFiles);
      onChange(updatedFiles);
    } else {
      const file = e.target.files[0];
      if (file) {
        const newFileName = `${prefix}${file.name}`;
        const newFile = new File([file], newFileName, { type: file.type });

        setValue(name, {
          file,
          name: newFile.name,
          fileId: `temp-fileId-${newFile.name}-${new Date().getTime()}`,
        });
        onChange({
          file,
          name: newFile.name,
          fileId: `temp-fileId-${newFile.name}-${new Date().getTime()}`,
        });
      }
    }
  };

  const onRemoveFile = (fileId) => {
    if (rest.multiple) {
      const updatedFiles = files.filter((file) => file.fileId !== fileId);
      setValue(name, updatedFiles);
      onChange(updatedFiles);
    } else {
      setValue(name, null);
      onChange(null);
    }
  };

  useEffect(() => {
    if (files) trigger(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  return (
    <div className={className}>
      <input
        type="file"
        multiple={rest.multiple}
        name={name}
        className="hidden"
      />
      <label
        className={`bg-white border ${
          errors[name] ? "border-error" : "border-gray-border"
        } rounded px-4 h-[56px] flex justify-between items-center gap-2 cursor-pointer`}
      >
        <input
          type="file"
          className="hidden"
          {...rest}
          onChange={handleChange}
        />
        <span className="text-[#999999]">
          {rest?.placeholder || t("common.file.defaultPlaceholder")}
        </span>
        <div className="bg-primary rounded text-white px-4 py-1 text-sm font-medium">
          파일 업로드
        </div>
      </label>
      {errors[name] ? (
        <p className="text-sm text-error">{errors[name]?.message}</p>
      ) : hint ? (
        <p className="text-sm text-[#999]">{hint}</p>
      ) : null}

      {rest.multiple ? (
        <>
          {files?.length > 0 && (
            <ul className="flex items-center flex-wrap gap-6 mt-4">
              {files.map((file) => (
                <li
                  key={file.fileId}
                  className="flex items-center gap-2 rounded border border-gray-border p-2"
                >
                  {getFileIcon(file.name)}
                  <span className="text-sm font-medium">{file.name}</span>
                  <span
                    className="flex w-5 h-5 justify-center items-center rounded bg-gray-200 cursor-pointer"
                    onClick={() => onRemoveFile(file.fileId)}
                  >
                    <FontAwesomeIcon icon={faMinus} size="xs" />
                  </span>
                </li>
              ))}
            </ul>
          )}
        </>
      ) : (
        <>
          {files && (
            <div className="mt-4 inline-flex items-center gap-2 rounded border border-gray-border p-2">
              {getFileIcon(files.name)}
              <span className="text-sm font-medium">{files.name}</span>
              <span
                className="flex w-5 h-5 justify-center items-center rounded bg-gray-200 cursor-pointer"
                onClick={() => onRemoveFile(files.fileId)}
              >
                <FontAwesomeIcon icon={faMinus} size="xs" />
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MyInputFile;
